function scroll2() {
    const link = $('.js-scroll-link');

    link.on('click', function(e){
        e.preventDefault();
        APP.websiteWrapper.scrollTo(this.hash, this.hash);
    });

}